import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Label } from 'reactstrap';
import otpAuthenticationStatus from '../../../constans/otpAuthenticationStatus';
import { createOtpLogin, validateOtpLogin } from './../../../utilities/authentication/authenticationSlice';

export default function OtpAuthTester(props) {

  const dispatch = useDispatch();

  const otpState = useSelector(state => state.authentication.otp);

  const phoneRef = useRef();
  const codeRef = useRef();
  const sendTypeRef = useRef();
  const configNameRef = useRef();

  function handlePhoneSubmit(e) {
    e.preventDefault();

    const data = {
      phoneNumber: phoneRef?.current?.value,
      sendAsTextToSpeech: sendTypeRef?.current?.value == 'SendAsTextToSpeech',
      configName: configNameRef?.current?.value,
    }
    dispatch(createOtpLogin(data));
  }

  function handleCodeSubmit(e) {
    e.preventDefault();

    const data = {
      code: codeRef.current.value,
    }
    dispatch(validateOtpLogin(data));
  }

  return (
    <div style={{ direction: 'ltr', textAlign: 'left', fontSize: '13px' }}>
      <div>
        <div>Status: {otpState.status}</div>
        <br />
        <div>Error: {otpState.error?.message}</div>
        <br />
        state.authentication.otp:
        <br />
        <textarea value={JSON.stringify(otpState, null, '\t')} cols="70" rows="10"></textarea>
      </div>
      <br />
      <form id="phone" onSubmit={handlePhoneSubmit}>
        <input ref={phoneRef} placeholder="phone number" />
        <br />
        <br />
        <label> Send type
          <select ref={sendTypeRef}>
            <option value="Sms">Sms</option>
            <option value="SendAsTextToSpeech">SendAsTextToSpeech</option>
          </select>
        </label>
        <br />
        <label> Config type
          <select ref={configNameRef}>
            <option value="OTP_SALE">SALE</option>
            <option value="OTP_FUNDIAL">FUNDIAL</option>
          </select>
        </label>
        <br />
        <button>Submit</button>
      </form>
      <br />
      {(otpState.status != otpAuthenticationStatus.INITIALEIZED && otpState.status != otpAuthenticationStatus.CREATE_OTP_PENDING && otpState.status != otpAuthenticationStatus.CREATE_OTP_FAIL) &&
        <form id="code" onSubmit={handleCodeSubmit}>
          <input ref={codeRef} placeholder="code" />
          <button>Submit</button>
        </form>
      }
    </div>
  )

}